import {Injectable} from '@angular/core';
import {Observable, shareReplay} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestCacheService {
    private requests: Map<string, Observable<any>> = new Map();

    constructor() {
    }

    public getOrAddRequestObservable<T>(key: string, requestFactory: () => Observable<T>): Observable<T> {
        if (!this.requests.has(key)) {
            const request = requestFactory().pipe(
                shareReplay(1)
            );
            this.requests.set(key, request);

            request.subscribe({
                complete: () => this.requests.delete(key),
                error: () => this.requests.delete(key)
            });
        }

        return this.requests.get(key) as Observable<T>;
    }
}
